import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.activitiesListFilter.loading;
export const selectErrorMessage = (state: RootState) =>
  state.activitiesListFilter.error;
export const activitiesListFilterDataResponse = (state: RootState) =>
  state.activitiesListFilter.activityFilterResponse;
